import { render } from "./Sidebar.vue?vue&type=template&id=c5ed00f0&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=c5ed00f0&scoped=true&lang=css"

import exportComponent from "D:\\0001 Project\\bling\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ed00f0"]])

export default __exports__